const { signupServiceUrl } = window.siteInfo || {};

export const SIGNUP_SERVICE_URL = signupServiceUrl;
export const LEAD_REGISTRATION_API = `${SIGNUP_SERVICE_URL}/services/leadRegistration`;
export const UPDATE_CONTACT_API = `${SIGNUP_SERVICE_URL}/services/updateContact`;
export const INTEGRATION_REQUEST_API = `${SIGNUP_SERVICE_URL}/services/integrationRequest`;
export const BRANDID = '5f472e89-7ebd-44a4-9169-82c5428c9549';
export const COMPANY_CONTACT_UPDATE_API = `${SIGNUP_SERVICE_URL}/services/updateCompanyContact`;
export const BRAND_NAME = 'Branding-LexReception-CA';
